import React from 'react';
import Loadable from 'react-loadable';

import { connect } from "react-redux";

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

import PrivateRoute from 'src/components/private-route';
import { RouteLoader, MonestLoader } from 'src/components/loader';

/**
 * Template import.
 */
import AdminTemplate from 'src/templates/admin';

/**
 * Actions import.
 */
import { logout } from 'modules/auth/actions/authentication.action';

/**
 * Lazy modules import.
 */
const Dashboard = Loadable({
    loader: () => import('src/modules/dashboard'),
    loading: () => <MonestLoader size={6} />,
});

const Debtors = Loadable({
    loader: () => import('src/modules/debtors'),
    loading: () => <MonestLoader size={6} />,
});

const Requests = Loadable({
    loader: () => import('modules/requests'),
    loading: () => <MonestLoader size={6} />,
});

const Debts = Loadable({
    loader: () => import('src/modules/debts'),
    loading: () => <MonestLoader size={6} />,
});

const Deals = Loadable({
    loader: () => import('src/modules/deals'),
    loading: () => <MonestLoader size={6} />,
});

const Config = Loadable({
    loader: () => import('src/modules/config'),
    loading: () => <MonestLoader size={6} />,
});

const Campaign = Loadable({
    loader: () => import('src/modules/campaign'),
    loading: () => <RouteLoader />,
});

const Product = Loadable({
    loader: () => import('src/modules/product'),
    loading: () => <RouteLoader />,
});

const Financial = Loadable({
    loader: () => import('src/modules/financial'),
    loading: () => <RouteLoader />,
});

const Surveys = Loadable({
    loader: () => import('src/modules/surveys'),
    loading: () => <RouteLoader />,
});

/* Redux state map */
const mapStateToProps = state => ({
    authUser: state.authentication.authUser,
});

/* Redux dispatch map */
const mapDispatchToProps = { logout };

/**
 * Admin routes.
 */
const Admin = ({ logout, authUser, ...props }) => {
    const match = useRouteMatch();

    if (!authUser) {
        return <Redirect to='/auth/login' />;
    }

    if (!authUser.has_debt) {
        return <Redirect to='/importer/introduction' />;
    }

    if (authUser.has_debt && !authUser.completed_profile) {
        return <Redirect to='/importer/complete-profile' />;
    }

    return (
        <AdminTemplate {...props}>
            <Switch>
                <PrivateRoute path={`${match.url}/dashboard`} component={Dashboard} />
                <PrivateRoute path={`${match.url}/debtors`} component={Debtors} />
                <PrivateRoute path={`${match.url}/requests`} component={Requests} />
                <PrivateRoute path={`${match.url}/debts`} component={Debts} />
                <PrivateRoute path={`${match.url}/deals`} component={Deals} />
                <PrivateRoute path={`${match.url}/config`} component={Config} />
                <PrivateRoute path={`${match.url}/campaign`} component={Campaign} />
                <PrivateRoute path={`${match.url}/product`} component={Product} />
                <PrivateRoute path={`${match.url}/financial`} component={Financial} />
                <PrivateRoute path={`${match.url}/surveys`} component={Surveys} />

                {/* Temporary logout route */}
                <Route path={`${match.url}/logout`} render={() => {
                    logout();
                    return <Redirect to="/auth/login" />;
                }}
                />

                {/* Router Fallabck */}
                <Route render={() => <Redirect to={`${match.url}/dashboard`} />} />
            </Switch>
        </AdminTemplate>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);